// mdx-deck-template for /home/circleci/project/src/decks/crystal-tokyo-8/index.mdx

import {graphql} from 'gatsby';
import React from 'react';

import SlideDeckWrapper from '/home/circleci/project/src/components/slide-deck-wrapper.js';
import slides, {theme} from '/home/circleci/project/src/decks/crystal-tokyo-8/index.mdx';

const MdxDeckTemplate = ({data}) =>
  <SlideDeckWrapper
    data={data}
    slides={slides}
    theme={theme}
  />;

export default MdxDeckTemplate;


export const query = graphql`
  query($id: String!) {
    site {
      siteMetadata {
        title
      }
    }

    file(id: {eq: $id}) {
      fields {
        slug
        screenshotUrl
        frontmatter {
          title
          date
        }
      }
    }
  }
`;
